import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { getDefaultTranslations } from "../Services/config-service";

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: {
                translation: getDefaultTranslations()
            }
        }
    });

i18n.changeLanguage("en");
